import React from "react";

function ProdictImages({ product }) {
  return (
    <div className="imgs_item">
      <div className="mg_img">
        <img id="bg_img" src={product.images[0]} alt={product.title} />
      </div>
      <div className="sm_img">
        {product.images.map((img, index) => (
          <div className="img-div-sm">
            <img
              key={index}
              src={img}
              alt={product.title}
              onClick={() => (document.getElementById("bg_img").src = img)}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProdictImages;
